import {
  initIndexRecipeFloat,
  initRecipeSmoothScroll,
} from './kij-recipe-body/js';
import { initBlogLoader } from './blog-loader/js';
import { initBlogBody } from './blog-body/js';

export const initKijModules = () => {
  initIndexRecipeFloat();
  initRecipeSmoothScroll();
  initBlogLoader();
  initBlogBody();
};
